import { useState } from "react";
import { toast } from "sonner";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "../ui/card";
import { portalChangePassword } from "../../lib/api";

export function PortalChangePassword({ forced = false, onDone }) {
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!current || !next) { toast.error("Please fill in all fields"); return; }
    if (next.length < 8) { toast.error("New password must be at least 8 characters"); return; }
    if (next !== confirm) { toast.error("Passwords don't match"); return; }
    setLoading(true);
    try {
      await portalChangePassword(current, next);
      toast.success("Password changed");
      setCurrent(""); setNext(""); setConfirm("");
      onDone && onDone();
    } catch (err) {
      toast.error(err.response?.data?.detail || "Failed to change password");
    } finally { setLoading(false); }
  };

  const form = (
    <form onSubmit={submit} className="space-y-4" data-testid="portal-change-password-form">
      <div className="space-y-2">
        <Label htmlFor="pcp-current">Current Password</Label>
        <Input id="pcp-current" type="password" value={current} onChange={(e) => setCurrent(e.target.value)} data-testid="portal-current-password" />
      </div>
      <div className="space-y-2">
        <Label htmlFor="pcp-new">New Password</Label>
        <Input id="pcp-new" type="password" placeholder="Min 8 chars, 1 letter + 1 number" value={next} onChange={(e) => setNext(e.target.value)} data-testid="portal-new-password" />
      </div>
      <div className="space-y-2">
        <Label htmlFor="pcp-confirm">Confirm New Password</Label>
        <Input id="pcp-confirm" type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} data-testid="portal-confirm-password" />
      </div>
      <Button type="submit" disabled={loading} className="bg-[#00305E] hover:bg-[#00305E]/90 w-full" data-testid="portal-change-password-btn">
        {loading ? "Saving..." : "Change Password"}
      </Button>
    </form>
  );

  if (forced) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-[#00305E]/5 via-white to-[#A62E1D]/5 p-4">
        <Card className="w-full max-w-md border-0 shadow-xl" data-testid="portal-force-change">
          <CardHeader>
            <CardTitle className="text-2xl font-bold">Set your password</CardTitle>
            <CardDescription>For your security, please choose a new password before continuing.</CardDescription>
          </CardHeader>
          <CardContent>{form}</CardContent>
        </Card>
      </div>
    );
  }

  return (
    <Card>
      <CardHeader><CardTitle className="text-lg">Change Password</CardTitle></CardHeader>
      <CardContent className="max-w-md">{form}</CardContent>
    </Card>
  );
}

export default PortalChangePassword;
